import React, {useEffect, useState} from 'react';
import MultiDdl from "components/componentsForm/multiDdl";
import ApiDataBase from 'server'
import UseContext from "hooks/useContext";
import SectionWrapper, {FormField} from "../components/SectionWrapper";

const Prerequis = () => {
    const {page,data,setData}=UseContext()
    const [lLang,setLLang]=useState([])
    const [lTools,setLTools]=useState([])
    const [lLicences,setLLicences]=useState([])
    const [selectLng,setSelectLng]=useState([])
    const [selectTools,setSelectTools]=useState([])
    const [selectLicences,setSelectLicences]=useState([])
    const [oDefaultLng,setODefaultLng]=useState([])
    const [oDefaultTools,setODefaultTools]=useState([])
    const [oDefaultLicences,setOdefaultLicences]=useState([])


    useEffect(()=>{
        setData(prevData=>({...prevData,
            tools:selectTools,
            languages:selectLng,
            licences:selectLicences}))
    },[selectLng,selectLicences,selectTools])

    useEffect(()=>{
        if(data.tools?.length > 0 && selectTools.length === 0){
            setODefaultTools(data.tools)
            setSelectTools(data.tools)
        }
        if(data.licences?.length > 0 && selectLicences.length === 0){
            setODefaultLicences(data.licences)
            setSelectLicences(data.licences)
        }
        if(data.languages?.length > 0 && selectLng.length === 0){
            setODefaultLng(data.languages)
            setSelectLng(data.languages)
        }
    },[data])

    useEffect(()=>{
        if (page === 2){
            ApiDataBase.getAllLicence(
                (data) => {
                    setLLicences(data)
                },
                (err) => {
                    console.warn(err)
                }
            )
            ApiDataBase.getListTools(
                (data) => {
                    setLTools(data)
                },
                (err) => {
                    console.warn(err)
                }
            )
            ApiDataBase.getListLanguages(
                (data) => {
                    setLLang(data)
                },
                (err) => {
                    console.warn(err)
                }
            )
        }
    },[page])

    return (
        <SectionWrapper 
            title="Pré-requis" 
            description="Indiquez les compétences et équipements nécessaires pour cette mission."
        >
            <FormField label="Matériel nécessaire" optional>
                   <MultiDdl data={lTools} selectArray={setSelectTools} defaultSelect={selectTools}/>
            </FormField>
            <FormField label="Permis nécessaire" optional>
                    <MultiDdl data={lLicences} selectArray={setSelectLicences} defaultSelect={selectLicences}/>
            </FormField>
            <FormField label="Langue nécessaire" optional>
                    <MultiDdl data={lLang} selectArray={setSelectLng} defaultSelect={selectLng}/>
            </FormField>
        </SectionWrapper>
    );
};

export default Prerequis;
